import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectRedirect = createSelector(
  [(store: RootState) => store.userAuthentication.redirect],
  (path) => path || ""
);
